import React from "react";

const TermsOfUse = () => {

    return (
      <div className={"card"}>
          <div className={"card-title"} >
                 <h1 className="title is-2" > <center> Terms and Conditions</center> </h1>
          </div>

      </div>
    );
}
export default TermsOfUse;
